import React, { useState, useEffect } from "react";
import styles from "../../styles/PantallaDeProgramasAcademicos.v2.module.css";
import { getInstitutions } from '../../api/institutions';

const defaultForm = {
  institucion: "",
  nombre: "",
  codigo: "",
  descripcion: "",
  estado: "ACTIVO",
  orden: 1,
};

export default function NuevaSeccionModal({ open, onClose, onSubmit, initialData }) {
  const [form, setForm] = useState(initialData ? {
    institucion: initialData.institucion || "",
    nombre: initialData.nombre || "",
    codigo: initialData.codigo || "",
    descripcion: initialData.descripcion || "",
    estado: initialData.estado || "ACTIVO",
    orden: initialData.orden || 1,
  } : defaultForm);
  const [institutions, setInstitutions] = useState([]);

  useEffect(() => {
    if (open) {
      getInstitutions().then(setInstitutions);
    }
  }, [open]);

  useEffect(() => {
    if (open && initialData) {
      setForm({
        institucion: initialData.institucion || "",
        nombre: initialData.nombre || "",
        codigo: initialData.codigo || "",
        descripcion: initialData.descripcion || "",
        estado: initialData.estado || "ACTIVO",
        orden: initialData.orden || 1,
      });
    } else if (open) {
      setForm(defaultForm);
    }
  }, [open, initialData]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(form);
    setForm(defaultForm);
    onClose?.();
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader} style={{ background: '#d1d1d1', padding: '18px 24px 12px', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
          <h2 style={{ fontWeight: 700, fontSize: '20px', margin: 0 }}>Nueva Sección Académica</h2>
        </div>
        <form className={styles.modalBody} style={{ display: 'flex', flexDirection: 'column', gap: '18px', padding: '24px 32px 32px' }} onSubmit={handleSubmit}>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Institución</label>
            <select name="institucion" value={form.institucion} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} required>
              <option value="">-- Selecciona una institución --</option>
              {institutions.map(inst => (
                <option key={inst.id} value={inst.id}>{inst.name}</option>
              ))}
            </select>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Nombre de Sección</label>
            <input name="nombre" value={form.nombre} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Código</label>
            <input name="codigo" value={form.codigo} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Descripción</label>
            <textarea name="descripcion" value={form.descripcion} onChange={handleChange} className={styles.input} style={{ minHeight: '60px', borderRadius: '6px', border: '1px solid #ccc', padding: '8px 10px' }} />
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Estado</label>
            <select name="estado" value={form.estado} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', background: '#e8f5e9', color: '#2e7d32', fontWeight: 700, padding: '0 10px' }}>
              <option value="ACTIVO">ACTIVO</option>
              <option value="INACTIVO">INACTIVO</option>
            </select>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Orden</label>
            <input type="number" name="orden" value={form.orden} onChange={handleChange} className={styles.input} min={1} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
          </div>
          <div style={{ display: 'flex', gap: '18px', marginTop: '18px', justifyContent: 'center' }}>
            <button type="submit" style={{ background: '#1a3764', color: '#fff', fontWeight: 700, border: 'none', borderRadius: '6px', padding: '10px 38px', fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>GUARDAR</button>
            <button type="button" style={{ background: '#b7b7b7', color: '#fff', fontWeight: 700, border: 'none', borderRadius: '6px', padding: '10px 38px', fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.10)' }} onClick={onClose}>CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  );
}
